'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emailList = require('./remote/emailList');

var EmailList = {
    fetchEmailLists: _emailList.EmailListRemote.fetchEmailLists,
    postSubscribeToEmailList: _emailList.EmailListRemote.postSubscribeToEmailList,
    postUnsubscribeFromEmailList: _emailList.EmailListRemote.postUnsubscribeFromEmailList
};

exports.default = EmailList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/emailList.js
// module id = kA98
// module chunks = 60